module.exports = __webpack_public_path__ + "Logo-GPI.png?e7b013d9f978c1176764f4519b06bd4f";


//////////////////
// WEBPACK FOOTER
// ./src/views/Contratos/Logo-GPI.png
// module id = 12
// module chunks = 0